interface UserAgentDataLike {
  platform?: string
}

function getPlatformHint(): string {
  if (typeof navigator === 'undefined') return ''

  // Chromium exposes a clean platform string ("macOS", "Windows"); everything
  // else has to fall back to the UA, where iPadOS still reports "MacIntel" —
  // correct here, since an iPad keyboard does carry a Command key.
  const { userAgentData } = navigator as Navigator & {
    userAgentData?: UserAgentDataLike
  }

  return userAgentData?.platform || navigator.userAgent
}

/** Whether the keyboard in front of the user has a Command key. */
export function isMacPlatform(): boolean {
  return /mac|iphone|ipad|ipod/i.test(getPlatformHint())
}

/**
 * Renders a modifier shortcut the way the user's own keyboard is labelled —
 * `⌘K` on Apple hardware, `Ctrl+K` everywhere else. Handlers accept both
 * modifiers regardless; this is presentation only.
 */
export function formatShortcut(key: string): string {
  return isMacPlatform() ? `⌘${key}` : `Ctrl+${key}`
}
